var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M118.973,157.361c2.182-2.182,5.224-3.549,8.575-3.549c6.701,0,12.124,5.423,12.124,12.124v30.684l16.466-16.466 c4.739-4.739,12.41-4.739,17.149,0c4.739,4.739,4.739,12.41,0,17.149l-37.165,37.165l-0.022,0.022 c-1.411,1.411-3.174,2.469-5.092,3.02c0,0,0,0-0.022,0c-2.381,0.705-4.96,0.639-7.296-0.132c-1.763-0.595-3.395-1.609-4.717-2.91 l-37.165-37.209c-4.739-4.739-4.739-12.41,0-17.149c4.739-4.739,12.41-4.739,17.149,0l16.466,16.466v-30.662 C115.424,162.585,116.791,159.544,118.973,157.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M118.973,98.595c2.182,2.182,5.224,3.549,8.575,3.549c6.701,0,12.124-5.423,12.124-12.124V59.358l16.466,16.466 c4.739,4.739,12.41,4.739,17.149,0c4.739-4.739,4.739-12.41,0-17.149l-37.165-37.143L136.1,21.51 c-1.411-1.411-3.174-2.469-5.092-3.02c0,0,0,0-0.022,0c-2.381-0.705-4.96-0.639-7.296,0.132c-1.763,0.595-3.395,1.609-4.717,2.91 L81.808,58.697c-4.739,4.739-4.739,12.41,0,17.149c4.739,4.739,12.41,4.739,17.149,0l16.466-16.488v30.684 C115.424,93.37,116.791,96.412,118.973,98.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M34.152,143.408h187.674c8.531,0,15.43-6.899,15.43-15.43s-6.899-15.43-15.43-15.43H34.174c-8.531,0-15.43,6.899-15.43,15.43 S25.643,143.408,34.152,143.408z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.61c770adb42a8abd2ee0e6d36d817450.svg";
export { ForwardRef as ReactComponent };